import { render, staticRenderFns } from "./orderThanks.vue?vue&type=template&id=23033c4a&"
import script from "./orderThanks.vue?vue&type=script&lang=ts&"
export * from "./orderThanks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports